<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <transition name="c-onboarding__fade">
    <div v-if="view" class="c-onboarding">
      <div class="c-onboarding__wrapper">
        <div class="c-onboarding__body">
          <button @click="close" type="button" class="c-onboarding__close">
            <base-icon width="26" height="26" name="painel/close-icon" />
          </button>

          <hooper
            @slide="onSlide"
            :settings="hooperSettings"
            ref="hooperCarousel"
          >
            <slide v-for="(slide, index) in slidesFiltered" :key="index">
              <div class="c-onboarding__header">
                <img
                  :src="slide.image"
                  :alt="slide.title"
                  :title="slide.title"
                />
                <div :style="slide.position" class="c-onboarding__circle"></div>
              </div>
              <div class="c-onboarding__content">
                <h3>{{ slide.title }}</h3>
                <div v-html="slide.content">
                  <p>{{ slide.content }}</p>
                </div>
              </div>
            </slide>

            <hooper-pagination slot="hooper-addons" />
          </hooper>

          <div
            class="c-onboarding__controls columns is-mobile is-centered is-vcentered"
          >
            <div class="column">
              <button
                @click.prevent="slidePrev"
                type="button"
                rel="prev"
                class="button is-outlined is-big"
              >
                Voltar
              </button>
            </div>
            <div class="column">
              <button
                v-if="!isLastSlide"
                @click.prevent="slideNext"
                type="button"
                rel="next"
                class="button is-fullwidth is-primary is-big"
              >
                Avançar
              </button>
              <button
                v-else
                @click="close"
                type="button"
                rel="next"
                class="button is-fullwidth is-support is-big"
              >
                Concluir
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { Hooper, Slide, Pagination as HooperPagination } from 'hooper'
import OnboardingData from './OnboardingData'
import WalletApi from '@/lib/api/Wallet'
import 'hooper/dist/hooper.css'

export default {
  components: {
    HooperPagination,
    Hooper,
    Slide,
  },

  computed: {
    walletSummary() {
      return this.$store.state.wallet.walletSummary
    },

    walletNotifications() {
      return this.$store.getters.walletNotifications
    },

    logonToken() {
      return this.$store.state.app.logonToken
    },

    slidesFiltered() {
      if (
        this.walletSummary.wallet.settings &&
        this.walletSummary.wallet.settings.shopping
      ) {
        return this.slides.filter((slide, index) => index != 4)
      }
      return this.slides.filter((slide, index) => index != 3)
    },
  },

  data() {
    return {
      view: false,
      globalTagHTML: null,
      slides: OnboardingData,
      hooperSettings: {
        itemsToShow: 1,
        wheelControl: false,
      },
      isLastSlide: false,
    }
  },

  mounted() {
    this.start()
  },

  watch: {
    walletSummary(payload) {
      if (!payload.pending && !payload.loading && !this.view) this.start()
    },
  },

  methods: {
    start() {
      if (
        !this.walletSummary.pending &&
        !this.walletSummary.loading &&
        !this.view &&
        !this.walletNotifications.onboard_presented_at
      ) {
        this.view = true
        this.fixGlobalTagHTML()
      }
    },

    close() {
      const walletApi = new WalletApi(this.logonToken)
      walletApi
        .setOnboardPresented()
        .catch(console.warn('Set Onboard presented failed'))
        .finally(() => {
          this.view = false
          this.fixGlobalTagHTML()
        })
    },

    fixGlobalTagHTML() {
      if (this.globalTagHTML === null)
        this.globalTagHTML = document.getElementsByTagName('html')[0]

      if (this.view) {
        this.globalTagHTML.style.position = 'fixed'
        this.globalTagHTML.style.overflow = 'hidden'
      } else {
        this.globalTagHTML.style.position = 'relative'
        this.globalTagHTML.style.overflow = 'initial'
      }
    },

    onSlide(e) {
      this.setLastSlide(e.currentSlide)
    },

    setLastSlide(index) {
      if (index + 1 === this.slidesFiltered.length) this.isLastSlide = true
      else this.isLastSlide = false
    },

    slidePrev() {
      this.$refs.hooperCarousel.slidePrev()
    },

    slideNext() {
      this.$refs.hooperCarousel.slideNext()
    },
  },
}
</script>

<style lang="scss">
.c-onboarding {
  @include position(fixed, 0, 0, 0, 0);
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 203;
  background-color: $overlay;

  &__fade-enter-active,
  &__fade-leave-active {
    transition: opacity 0.5s;
  }
  &__fade-enter,
  &__fade-leave-to {
    opacity: 0;
  }

  &__wrapper {
    @include position(absolute, 0, 0, 0, 0);
    margin: 0 auto;
    width: 100%;
    max-height: 100%;
    background-color: $white;
    @media (min-width: $tablet) {
      @include position(absolute, 50%, 0, auto, 0, -50%);
      max-width: 420px;
    }
    @media (max-height: 600px) {
      overflow-y: initial;
    }
  }
  &__body {
    background-color: $white;
    @media (min-height: 580px) {
      @include position(absolute, 50%, 0, auto, 0, -50%);
    }
  }

  &__close {
    @include position(absolute, 1em, 1em, auto, auto);
    border: 0;
    z-index: 10;
    cursor: pointer;
    color: $gray-5;
    background-color: transparent;
    &:hover {
      color: $gray-7;
    }
  }

  &__header {
    position: relative;
    height: 300px;
    > img {
      @include position(absolute, 50%, 0, auto, 0, -50%);
      padding: 0 12px;
      margin: 0 auto;
      max-width: 372px;
      max-height: 275px;
      z-index: 2;
    }

    > .c-onboarding__circle {
      position: absolute;
      width: 350px;
      height: 350px;
      border-radius: 100%;
      z-index: 1;
      opacity: 0;
      transition: all 0.2s ease;
      background-color: #fcf3f6;
    }
  }

  &__content {
    padding: 0.5em 2em 2em;
    color: $gray-6;
    text-align: center;
    h3 {
      margin-bottom: 0.5em;
      font-size: em(24);
      font-weight: bold;
      color: $gray-7;
    }
    p {
      color: $gray-6;
      > strong {
        color: $gray-6;
      }
    }
  }

  &__controls {
    padding: 1em 2em 2em;
    text-align: center;
  }

  .hooper {
    min-height: 400px;
    height: auto;

    &-list {
      @media (max-width: $tablet) and (min-height: 575px) {
        overflow: visible;
      }
    }

    &-slide.is-active .c-onboarding__circle {
      opacity: 1;
    }

    &-navigation {
      display: none;
      visibility: hidden;
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      top: auto;
      @media (min-width: $tablet) {
        display: block;
        visibility: visible;
      }
      &-btn {
        position: absolute;
        top: auto;
        bottom: 0;
        width: 33px;
        height: 33px;
        border: 1px solid $gray-7;
        border-radius: 100%;
        color: transparent;
        outline: none;
        cursor: pointer;
        background-color: transparent;
        &:disabled {
          opacity: 0.2;
          cursor: default;
        }
        &--prev {
          left: 25px;
        }
        &--next {
          right: 25px;
        }
        &-svg {
          width: 90%;
          height: 100%;
          fill: $gray-7;
        }
      }
    }
    &-indicator {
      width: 6px !important;
      height: 6px !important;
      outline: none;
      transition: 0.5s all ease-in-out;
      background-color: $gray-4 !important;
      &.is-active {
        width: 14px !important;
        background-color: $primary !important;
      }
    }
  }
}
</style>
